 const getMockWidgetData = (reportName) => {
  switch(reportName) {
    case "Duplicate Billing":
      return [
        { WIDGET_NAME: "Total Charges for Duplicate Billing", REPORT_NAME: 'Duplicate Billing', REPORT_ID: 55, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Duplicate Billing Volume", REPORT_NAME: 'Duplicate Billing', REPORT_ID: 55, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
      ];
    case "Late Payment Fees":
      return [
        { WIDGET_NAME: "Total Charges for Late Payment Fees", REPORT_NAME: 'Late Payment Fees', REPORT_ID: 52, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Total Count of Invoices with Late Payment Fees", REPORT_NAME: 'Late Payment Fees', REPORT_ID: 52, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
      ];
    case "Inactive Accounts":
      return [
        { WIDGET_NAME: "Top Charges by Account Number", REPORT_NAME: 'Late Payment Fees', REPORT_ID: 60, WIDGET_TYPE: "Table", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Number of Invoices with Inactive Charges", REPORT_NAME: 'Late Payment Fees', REPORT_ID: 60, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Total Charges for Inactive Account", REPORT_NAME: 'Late Payment Fees', REPORT_ID: 60, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
      ];
    case "Cost Analysis":
        return [
          { WIDGET_NAME: "Average Week Spend", REPORT_NAME: 'Cost Analysis', REPORT_ID: 59, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
      ];
    case "UPS RFP":
      return [
        { WIDGET_NAME: "Total Benchmark Cost", REPORT_NAME: 'UPS RFP', REPORT_ID: 65, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Total New Cost", REPORT_NAME: 'UPS RFP', REPORT_ID: 65, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Total Savings", REPORT_NAME: 'UPS RFP', REPORT_ID: 65, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
      ];
    case "FedEx RFP":
      return [
        { WIDGET_NAME: "Total Benchmark Cost", REPORT_NAME: 'UPS RFP', REPORT_ID: 66, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Total New Cost", REPORT_NAME: 'UPS RFP', REPORT_ID: 66, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
        { WIDGET_NAME: "Total Savings", REPORT_NAME: 'UPS RFP', REPORT_ID: 66, WIDGET_TYPE: "Simple", WIDGET_AGG: "DISPLAY", WIDGET_FIELD: "VALUE" },
      ];
    default:
      return [
        { WIDGET_NAME: "Default Widget", WIDGET_TYPE: "bar", WIDGET_AGG: "SUM", WIDGET_FIELD: "CHARGE_AMOUNT" },
      ];
  }
};

export default getMockWidgetData